module.exports = __webpack_public_path__ + "img/marker_two_cyan1.ee2f2fbb.png";